const values = [
  {
    value: "unique",
    label: "No se repite",
  },
  {
    value: "personalized",
    label: "Personalizado",
  },
];

export default values;
